export default __webpack_public_path__ + "static/media/sounds.a9692e4a.wav";